import { api } from "@/lib/api";
import { fb } from "@/lib/firebase";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const messaging = getMessaging(fb);

const subscribeToPushNotifications = async (fcmToken: string) => {
  try {
    const userData = localStorage.getItem("user");
    const userId = userData ? JSON.parse(userData).id : null;

    if (!userId) return;

    await api.post(
      `${process.env.REACT_APP_BASE_URL}/api/User/subscribe-fcm/${userId}`,
      { FcmToken: fcmToken }
    );
    console.log("[Push] Token sent to backend:", fcmToken);
  } catch (error) {
    console.error("[Push] Error sending token to backend:", error);
  }
};

export const requestNotificationPermission = async () => {
  try {
    const permission = await Notification.requestPermission();
    return permission === "granted";
  } catch (error) {
    console.error("[Push] Error requesting permission:", error);
    return false;
  }
};

export const getFCMToken = async () => {
  try {
    const currentToken = await getToken(messaging, {
      vapidKey:
        "BFfdvEeAyUuRUl6pLyFWux294dOS0aDHwGKmjMlPzpP_8TXGZXsQmjRB3GCewmWujkBysoW5oNnCOkiHEvPNPtg",
    });

    if (currentToken) {
      console.log("[Push] Token received:", currentToken);
      await subscribeToPushNotifications(currentToken);
      return currentToken;
    }
    return null;
  } catch (error) {
    console.error("[Push] Error getting token:", error);
    return null;
  }
};

onMessage(messaging, (payload) => {
  console.log("[Push] Message received:", payload);

  if (Notification.permission === "granted") {
    new Notification(payload.notification?.title || "New Notification", {
      body: payload.notification?.body || "",
      icon: "/logo192.png",
      badge: "/logo512.png",
    });
  } else {
    console.warn("[Push] Notification permission not granted.");
  }
});
export default messaging;
